export default "__VITE_ASSET__CHs1NILj__"